import React, { useEffect, useMemo } from "react";
import moment from "moment";
import { useUserContext } from "../../../context/UserContext.tsx";
import { DataTable } from "../../../components/DataTable/index.ts";
import type { Column } from "../../../components/DataTable/index.ts";
import { StatusChip } from "../../../components/StatusChip/index.ts";

export default function GatewayTable({header}: {header: React.ReactNode}) {
  const { user, globalstorevalue } = useUserContext();
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    if (user?.stores?.length > 0) {
      setLoading(false);
    }
  }, [user]);

  const filteredData = useMemo(() => {
    if (!user?.stores) return [];

    const storesWithGateway = user.stores.filter((store: any) => {
      return store?.gateway_id && store?.gateway_status;
    });

    if (!globalstorevalue) {
      return storesWithGateway;
    }

    return storesWithGateway.filter((store: any) => store?._id === globalstorevalue);
  }, [user, globalstorevalue]);

  const columns: Column[] = [
    {
      key: "name",
      label: "Store Name",
      width: "25%",
      render: (value: string) => (
        <span className="font-semibold text-[rgb(var(--text-primary))]">{value}</span>
      ),
    },
    {
      key: "gateway_id",
      label: "MacId",
      width: "25%",
      render: (value: string) => (
        <span className="text-[rgb(var(--text-secondary))] font-mono text-[12px]">{value}</span>
      ),
    },
    {
      key: "gateway_last_updated",
      label: "Last Updated",
      width: "28%",
      render: (value: string) => (
        <span className="text-[12px] text-[rgb(var(--info))]">
          {value ? moment(value).format("DD/MM/YYYY hh:mm:ss A") : "N/A"}
        </span>
      ),
    },
    {
      key: "gateway_status",
      label: "Status",
      width: "22%",
      align: "center",
      render: (value: string) => {
        const variant = value === "connected" ? "success" : "danger";
        const label = value ? value.charAt(0).toUpperCase() + value.slice(1) : "Unknown";
        return <div className="flex justify-center"><StatusChip label={label} variant={variant} /></div>;
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={filteredData}
      rowKey="_id"
      loading={loading}
      skeletonRows={3}
      emptyMessage="No gateway data available."
      maxHeight="calc(100vh - 320px)"
      header={header}
    />
  );
}
